import React from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { formatCurrency, formatDate } from '../../../../utils/FormatUtil';
import './dropdownDetail.css';

const DropdownDetail = props => {
  const { data, onItemClick } = props;

  if (data.length === 0) {
    return null;
  }

  return (
    <DropdownButton
      id="list"
      alignRight
      title="Mis Depósitos a Plazo"
      variant="secondary"
    >
      {data.map((item, key) => {
        return key < 3 ? (
          <React.Fragment key={item.id}>
            <Dropdown.Item onClick={() => onItemClick(item.id)}>
              <p>
                Depósito a Plazo Nº <b>{item.id}</b>
              </p>
              <p>
                Vencimiento <b>{formatDate(item.fechaVencimiento)}</b>
                {' | '}Ganancia <b>{formatCurrency(item.montoRescate)}</b>
              </p>
            </Dropdown.Item>
            <Dropdown.Divider />
          </React.Fragment>
        ) : null;
      })}
      {data.length > 3 ? (
        <Link className="enlace" to="/listado">
          <span>Ver Todos</span>
        </Link>
      ) : (
        ''
      )}
    </DropdownButton>
  );
};

export default DropdownDetail;
